export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <img 
        src="https://public.readdy.ai/ai/img_res/f219e8ef772453e9df6788e5dad8b4b3.jpg" 
        alt="Hero Background" 
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h1 className="text-7xl font-bold leading-tight mb-6">
              Secure Your<br />
              Digital Life<br />
              Everywhere
            </h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Military-grade encryption protecting your online privacy across all devices
            </p>
            <button onClick={scrollToContact} className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-cyan-500 via-blue-600 to-purple-600 text-white text-lg font-semibold rounded-full hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer">
              Start Free Trial
              <div className="ml-3 w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                <i className="ri-arrow-right-line text-white"></i>
              </div>
            </button>
            <div className="flex items-center space-x-4 mt-6">
              <div className="flex items-center space-x-2">
                <i className="ri-shield-check-line text-green-400 text-xl"></i>
                <span className="text-sm text-gray-300">256-bit Encryption</span>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex justify-center">
            <img 
              src="https://readdy.ai/api/search-image?query=3D%20glowing%20shield%20with%20network%20connections%20in%20neon%20blue%20and%20purple%20tones%2C%20abstract%20cybersecurity%20illustration%20with%20geometric%20patterns%2C%20modern%20tech%20aesthetic%20with%20transparent%20background%2C%20digital%20protection%20concept%20for%20VPN%20security%20website&width=600&height=600&seq=hero-shield-001&orientation=squarish" 
              alt="Security Shield" 
              className="w-full max-w-md"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
